import styled from 'styled-components';
import { Tabs } from 'antd';

export const EditPane = styled.div`
  display: flex;
  flex-direction: row;
  width: 100;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  .ant-tabs-nav-wrap {
    margin-left: 20px;
  }
  .ant-tabs-bar {
    margin-bottom: 0;
  }
  .edit-mode {
    .button-list {
      border-top: 0;
    }
  }
  .ant-radio-button-wrapper {
    height: 24px;
    line-height: 23px;
    box-shadow: none;
    &.ant-radio-button-wrapper-checked:hover {
      box-shadow: none;
    }
  }
`;

export const EditControls = styled.div`
  padding: 0;
  flex: 1;
  width: 150px;
  max-width: 150px;
  button {
    margin-bottom: 5px;
  }
  .query-label {
    font-weight: normal;
    font-size: 1rem;
    color: #999999;
  }
  .query-clickable {
    border-color: #999999;
    &:focus {
      border-color: #4d99bf;
    }
  }
`;

export const EditLabel = styled.div`
  paddingLeft: '1rem'; 
  paddingRight: '1rem';
  white-space: nowrap;
  color: #a4a4a4;
  margin-right: 15px;
  min-width: 75px;
  text-align: right;
`;

export const EditLabelParam = styled.div`
  paddingLeft: '1rem'; 
  paddingRight: '1rem';
  white-space: nowrap;
  color: #a4a4a4;
  margin-right: 15px;
  min-width: 75px;
  text-align: right;
  text-transform: uppercase;
`;

export const EditValue = styled.div`
  flex: none;
  margin-right: 70px;
  flex-grow: inherit;
  position: relative;
  max-width: 80%;
`;

export const FlexDiv = styled.div`
  flex: 1;
  display: flex;
`;

export const EditPaneHeightControl = styled.div`
  text-align: center;
`;

export const EditContent = styled.div`
  flex: 1;
  margin-right: 15px;
`;

export const EditMode = styled.div`
  display: flex;
  flex: none;
  marginLeft: 15px;
  .ant-radio-button-wrapper-checked {
    color: #ffffff;
    background-color: #a5a5a5;
    border-color: #a5a5a5;
    span { 
      background-color: #a5a5a5;
    }
  }
`;

export const NumberField = styled.div`
    max-width: 90px;
    text-align: right;
    margin-bottom: 5px;
`;

export const HiddenNavTabs = styled(Tabs)`
  .ant-tabs-bar { display: none !important; }
`;

export const Results = styled.section`
  background-color: #dddddd;
  padding-bottom: 20px;
  .media-table {
    padding: 0 20px;
  }
  .button-list {
    border-top: 0;
  }
  .button-list-left {
    float: left;
  }
  .pagination-controls {
    button {
      background-color: #F9F9F9;
      color: #979797;
    }
  }
`;

Results.Header = styled.section`
    padding: 15px 20px 0;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: baseline;
    
    h2 {
      margin-right: 30px;
    }
    .count {
    margin-left: 1rem;
    margin-right: 1rem;
    }
`;
